import { render, staticRenderFns } from "./BGrupoDadosForm.vue?vue&type=template&id=22c64d70"
import script from "./BGrupoDadosForm.vue?vue&type=script&lang=js"
export * from "./BGrupoDadosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports